import { Link } from "react-router-dom";
import { createPortal } from "react-dom";
import { Home, Camera, MessageCircle, Lock, Calendar, BarChart2, Megaphone, Sofa } from "lucide-react";
import { FEATURE_MENU } from "@/pages/management/features/featureData";

const ICONS = { Home, Camera, MessageCircle, Lock, Calendar, BarChart2, Megaphone };

const colHeading = {
  fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.12em",
  textTransform: "uppercase", color: "#9A9A9A", marginBottom: 14, marginTop: 0,
};

export default function SolutionsMenu({ onClose, onMouseEnter, onMouseLeave }) {
  return createPortal(
    <>
      <div
        style={{ position: "fixed", inset: 0, top: "calc(68px + var(--ts-promo-height, 0px))", background: "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.45) 100%)", zIndex: 150, animation: "fadeIn 0.2s ease" }}
        onMouseEnter={onMouseLeave}
      />
      <div style={{ position: "fixed", top: "calc(68px + var(--ts-promo-height, 0px))", left: 0, right: 0, zIndex: 300 }}
        onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 5vw, 80px)" }}>
          <div style={{ background: "#fff", borderRadius: 18, boxShadow: "0 20px 48px -12px rgba(0,0,0,0.22)", overflow: "hidden", animation: "megaSlideDown 0.25s cubic-bezier(0.16, 1, 0.3, 1)", maxWidth: 360 }}>
            <div style={{ padding: "14px 28px 0" }}>
              <p style={{ ...colHeading, marginBottom: 8 }}>Full Airbnb Management</p>
            </div>
            <div className="mega-link-list" style={{ padding: "0 10px 10px", display: "flex", flexDirection: "column", gap: 2 }}>
              {FEATURE_MENU.map((item) => {
                const Icon = ICONS[item.icon] || Home;
                return (
                  <Link
                    key={item.slug}
                    to={`/management/${item.slug}`}
                    onClick={onClose}
                    style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 12px", borderRadius: 8, textDecoration: "none", transition: "background 0.15s" }}
                    onMouseEnter={e => e.currentTarget.style.background = "#F7F7F5"}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                  >
                    <div className="mega-icon-box" style={{ width: 24, height: 24, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <Icon size={18} color="#555" strokeWidth={1.8} />
                    </div>
                    <p style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 14, color: "#1A1A1A", margin: 0, lineHeight: 1.2 }}>{item.label}</p>
                  </Link>
                );
              })}
              <div style={{ height: 1, background: "#F0F0F0", margin: "8px 6px" }} />
              <Link
                to="/interiors"
                onClick={onClose}
                style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 12px", borderRadius: 8, textDecoration: "none", transition: "background 0.15s" }}
                onMouseEnter={e => e.currentTarget.style.background = "#F7F7F5"}
                onMouseLeave={e => e.currentTarget.style.background = "transparent"}
              >
                <div className="mega-icon-box" style={{ width: 24, height: 24, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Sofa size={18} color="#555" strokeWidth={1.8} />
                </div>
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 14, color: "#1A1A1A", margin: 0, lineHeight: 1.2 }}>Interiors & Staging</p>
                <span style={{ marginLeft: "auto", fontFamily: "'DM Sans', sans-serif", fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "#fff", background: "#112215", borderRadius: 100, padding: "2px 8px" }}>Add-on</span>
              </Link>
            </div>
          </div>
        </div>
        <style>{`
          @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
          .mega-link-list > a:hover .mega-icon-box svg { color: #1A1A1A !important; }
          @keyframes megaSlideDown { from { opacity: 0; transform: translateY(-12px); } to { opacity: 1; transform: translateY(0); } }
        `}</style>
      </div>
    </>,
    document.body
  );
}